module.exports = __webpack_public_path__ + "img/logo-123.93008545.png";